import React, { useContext } from 'react'
import WorkshopDetails from '../Workshop-details'
import FileUpload from '../FileUpload'
import { DataContext } from '../../DataContext'
import Prepare from '../Prepare'

const KDDLanding: React.FC = () => {
  const { currentScreen } = useContext(DataContext)

  /**
   * NOTE: This needs a refactor - Again, found a custom 'router' impl.
   * */
  return (
    <div>
      {currentScreen === 'WorkshopDetails' && <WorkshopDetails />}
      {currentScreen === 'fileUpload' && <FileUpload />}
      {currentScreen === 'prepare' && <Prepare />}
    </div>
  )
}

export default KDDLanding
